import { Flame, ShieldCheck, ShieldAlert } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";

// Priority source + genuine / check-this-lead badges — trustedge
// customers/lead_quality.py. Fed by the list API's is_priority, quality and
// quality_reasons; the sources are set in Settings -> Lead Priority.

const pill = "inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-semibold border whitespace-nowrap";
const big = "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium border whitespace-nowrap";

export default function LeadQualityBadges({ row, size = "sm", className }) {
    if (!row) return null;
    const { is_priority: priority, quality } = row;
    if (!priority && !quality) return null;
    const reasons = (row.quality_reasons || []).join("\n");
    const base = size === "lg" ? big : pill;
    const icon = size === "lg" ? "h-3 w-3" : "h-2.5 w-2.5";

    return (
        <div className={cn("flex flex-wrap items-center gap-1", size !== "lg" && "mt-0.5", className)}>
            {priority && (
                <span className={cn(base, "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-900/20 dark:text-orange-300 dark:border-orange-800/50")}
                      title={`Priority source: ${(row.lead_source || '').trim()} - call first`}>
                    <Flame className={icon} /> Priority
                </span>
            )}
            {quality === "genuine" && (
                <span className={cn(base, "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800/50")}
                      title={`Genuine lead:\n${reasons}`}>
                    <ShieldCheck className={icon} /> Genuine
                </span>
            )}
            {quality === "suspect" && (
                <span className={cn(base, "bg-red-50 text-red-700 border-red-200 dark:bg-red-900/20 dark:text-red-300 dark:border-red-800/50")}
                      title={`May be fake or spam:\n${reasons}`}>
                    <ShieldAlert className={icon} /> Check lead
                </span>
            )}
        </div>
    );
}
